module.exports = __webpack_public_path__ + "static/media/Artboard6.62a9954d.png";